import {
  type PriceQuoteRequestBody,
  type BuyerOffersQuery,
  type CreateOfferRequest,
  type CreateCounterOfferRequest,
} from './aliases';

import {
  BUYER_ACTIVE_OFFERS_ENDPOINT,
  BUYER_INACTIVE_OFFERS_ENDPOINT,
  COUNTER_OFFERS_PRICE_QUOTE_V2_ENDPOINT,
  COUNTER_OFFER_ENDPOINT,
  DISMISS_OFFER_ENDPOINT,
  SUGGESTED_OFFERS,
  OFFERS_ENDPOINT,
  OFFERS_PRICE_QUOTE_V2_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { replacePathParams } from '@/modules/http/replacePathParams';

export function createOffer(body: CreateOfferRequest) {
  return typedHttp.post(OFFERS_ENDPOINT, body, {
    withAuth: true,
    withDeviceId: true,
  });
}

export function createCounterOffer(
  offerId: string,
  body: CreateCounterOfferRequest
) {
  return typedHttp.post(
    replacePathParams(COUNTER_OFFER_ENDPOINT, { offer_id: offerId }),
    body,
    {
      withAuth: true,
      withDeviceId: true,
    }
  );
}

export async function createOfferPriceQuote(body: PriceQuoteRequestBody) {
  return typedHttp.post(OFFERS_PRICE_QUOTE_V2_ENDPOINT, body, {
    withAuth: true,
    withDeviceId: true,
  });
}

export async function createCounterOfferPriceQuote(
  offerId: string,
  body: PriceQuoteRequestBody
) {
  return typedHttp.post(
    replacePathParams(COUNTER_OFFERS_PRICE_QUOTE_V2_ENDPOINT, { offerId }),
    body,
    {
      withAuth: true,
      withDeviceId: true,
    }
  );
}

export function fetchBuyerActiveOffers(
  params: Pick<BuyerOffersQuery, 'after' | 'limit'>
) {
  return typedHttp.get(BUYER_ACTIVE_OFFERS_ENDPOINT, {
    params: { ...params, include_checkout: 'true' } satisfies BuyerOffersQuery,
    withAuth: true,
    withDeviceId: true,
  });
}

export function fetchBuyerInactiveOffers(
  params: Pick<BuyerOffersQuery, 'after' | 'limit'>
) {
  return typedHttp.get(BUYER_INACTIVE_OFFERS_ENDPOINT, {
    params: { ...params, include_checkout: 'true' } satisfies BuyerOffersQuery,
    withAuth: true,
    withDeviceId: true,
  });
}

export function dismissOffer(offerId: string) {
  return typedHttp.post(
    replacePathParams(DISMISS_OFFER_ENDPOINT, { offerId }),
    null,
    { withAuth: true, withDeviceId: true }
  );
}

export function fetchSuggestedOffers(productId: string) {
  return typedHttp.get(replacePathParams(SUGGESTED_OFFERS, { productId }), {
    withAuth: true,
    withDeviceId: true,
  });
}
